import { inject, Injectable } from "@angular/core";

import { RouteService } from "@shared/services/route/route.service";
import { AntiFraudCardProps, AntiFraudProps } from "@shared/services/anti-fraud/anti-fraud.models";

export interface WindowKonduto extends Window {
  Konduto: any;
  __kdt: { public_key: string }[];
}

class Card {
  number!: string;

  expiration!: string;
}

@Injectable({
  providedIn: "root",
})
export class AntiFraudService {
  private routeService = inject(RouteService);

  private window = inject<WindowKonduto>("Window" as never);

  initScreenViewRouting() {
    this.routeService.getRouteDataOnRouteChange(this.sendPageViewEvent);
  }

  createAnalyzeParams(card?: Card): AntiFraudProps {
    let analyze = {
      visitor: this.getVisitorId(),
    };

    if (card) {
      const cardParams = this.createAnalyzeCardParams(card);

      analyze = {
        ...analyze,
        ...cardParams,
      };
    }

    return analyze;
  }

  private sendPageViewEvent = ({ data }: { data?: any }) => {
    const page = data?.pagePath;

    if (!page) {
      return;
    }

    this.window.Konduto?.sendEvent("page", page);
  };

  getVisitorId() {
    return this.window.Konduto?.getVisitorID() || "";
  }

  private createAnalyzeCardParams(card: Card): AntiFraudCardProps {
    return {
      bin: card.number.replace(/ /g, "").substring(0, 6),
      last4: card.number.substring(card.number.length - 4, card.number.length),
      expiration_date: card.expiration.replace(/\//g, ""),
    };
  }
}
